// Actions

import { INDEX_TAB_FORM, INDEX_TAB_FORM_RESET } from '../../actions/ui/tabs';

export const initialTabsState = {
  duplicateCommunication: {
    index: 1,
  },
  communication: {
    index: 0,
  },
  workOrdersGeneral: {
    index: 0,
  },
  action: {
    index: 0,
  },
  surveillanceRoute: {
    index: 0,
  },
  // Fase 3 nav Trabajo/Revisión (rework, 2026-07-12) — wrapper de pestañas
  // del LISTADO del módulo RV (`/surveillance-route`: Vista general +
  // Actuacions + Multimedia). Clave DISTINTA de `surveillanceRoute` (usada
  // por el detalle de cada RV y por NewRoute) para no compartir bookkeeping
  // de índice seleccionado entre 2 tab-bars con distinto número de pestañas.
  surveillanceRouteGeneral: {
    index: 0,
  },
  // Pestañas del LISTADO de Campañas (`/work-orders/campaign`,
  // `GeneralViewCampaignPage`: Campañas/Actuacions/Accidents/Comunicacions/
  // Multimedia) — espejo de `surveillanceRouteGeneral` arriba.
  campaignListGeneral: {
    index: 0,
  },
};

export const tabsType = {
  DUPLICATE_COMMUNICATION: 'duplicateCommunication',
  COMMUNICATION: 'communication',
  WORK_ORDERS_GENERAL: 'workOrdersGeneral',
  WORK_ORDERS_ACTION: 'workOrdersAction',
  SURVEILLANCE_ROUTE: 'surveillanceRoute',
  TRANSFER_SUBORDER: 'transferSuborder',
  EDIT_COMMUNICATION: 'editCommunication',
  SURVEILLANCE_ROUTE_GENERAL: 'surveillanceRouteGeneral',
  CAMPAIGN_LIST_GENERAL: 'campaignListGeneral',
  // Pestañas OTs / Campañas de «Vincular OT» (recorrido o aviso de un tramo).
  RELATE_ORDER_TO_ROUTE: 'relateOrderToRoute',
};

type actionType = {
  type: string;
  payload: { type: string; index: number };
};

export default function tabs(
  state = initialTabsState,
  { type, payload }: actionType
) {
  switch (type) {
    case INDEX_TAB_FORM:
      return {
        ...state,
        [payload.type]: {
           
          // @ts-ignore
          ...state[payload.type],
          index: payload.index,
        },
      };
    case INDEX_TAB_FORM_RESET:
      return {
        ...state,
        [payload.type]: {
           
          // @ts-ignore
          ...initialTabsState[payload.type],
        },
      };
    default:
      return state;
  }
}
